import type { SpecialTopic } from "@/types";

export const specials: SpecialTopic[] = [
  {
    id: "s1",
    title: "年度大片盛宴",
    subtitle: "2025 值得一看的华语重磅",
    intro: "从太空史诗到深海悬疑，盘点本年度最具话题度与口碑的重磅影片，带你一次看懂今年的大银幕。",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20festival%20special%20poster%2C%20a%20grand%20golden%20theater%20stage%20with%20dramatic%20spotlights%20and%20film%20reels%2C%20deep%20navy%20background%20with%20rich%20gold%20and%20orange%20accents%2C%20prestigious%20epic%20mood%2C%20high%20detail%20digital%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-special-s1&orientation=portrait",
    reason: "精选本年度最具代表性的华语影片，题材丰富、质量上乘，适合一次性建立观影清单。",
    movieIds: ["1001", "1003", "1004"],
  },
  {
    id: "s2",
    title: "悬疑烧脑精选",
    subtitle: "值得二刷的推理与反转",
    intro: "当真相藏在层层迷雾之后，这些作品用精巧的结构与反转让每一次重看都有新的发现。",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20genre%20special%20poster%2C%20a%20magnifying%20glass%20over%20scattered%20case%20files%20and%20photographs%20on%20a%20dark%20desk%20with%20a%20single%20warm%20lamp%2C%20deep%20navy%20and%20amber%20tone%2C%20tense%20intriguing%20mood%2C%20high%20detail%20digital%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-special-s2&orientation=portrait",
    reason: "推理线扎实、反转合理，适合喜欢动脑解谜的观众反复品味。",
    movieIds: ["1003", "1006", "2001"],
  },
  {
    id: "s3",
    title: "治愈系慢综艺",
    subtitle: "放松心情的温柔时光",
    intro: "不需要烧脑，也无需紧张，这些节目用旅行、美食与真诚的相处，为忙碌生活按下暂停键。",
    poster: "https://readdy.ai/api/search-image?query=Healing%20lifestyle%20variety%20special%20poster%2C%20a%20cozy%20sunlit%20countryside%20cottage%20with%20a%20swing%2C%20tea%20set%20and%20blooming%20garden%2C%20deep%20navy%20and%20soft%20warm%20gold%20tone%2C%20peaceful%20gentle%20mood%2C%20refined%20digital%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-special-s3&orientation=portrait",
    reason: "节奏舒缓、氛围温暖，是下班后放松心情、周末下饭的最佳搭档。",
    movieIds: ["3001", "3003"],
  },
  {
    id: "s4",
    title: "自然与人文纪实",
    subtitle: "看见真实世界的辽阔",
    intro: "从高原生命到千年丝路，从城市深夜到街头巷尾，纪录片以最真诚的镜头记录世界的多样与美好。",
    poster: "https://readdy.ai/api/search-image?query=Nature%20and%20culture%20documentary%20special%20poster%2C%20a%20vast%20landscape%20blending%20snow%20mountains%2C%20desert%20ruins%20and%20city%20lights%20into%20one%20surreal%20panorama%2C%20deep%20navy%20sky%20with%20golden%20horizon%20glow%2C%20majestic%20contemplative%20mood%2C%20high%20detail%20cinematic%20composition%2C%20vertical%20poster&width=600&height=900&seq=bbtv-special-s4&orientation=portrait",
    reason: "画面震撼、叙事扎实，既能增长见识，也能让人重新审视人与自然的关系。",
    movieIds: ["4001", "4002", "4003"],
  },
  {
    id: "s5",
    title: "青春成长纪事",
    subtitle: "关于喜欢与成为自己",
    intro: "那些关于校园、友情与初恋的片段，总能轻易勾起我们对青春最柔软的记忆。",
    poster: "https://readdy.ai/api/search-image?query=Nostalgic%20youth%20coming%20of%20age%20special%20poster%2C%20a%20bicycle%20leaning%20against%20a%20school%20wall%20under%20autumn%20trees%20with%20scattered%20notes%20and%20warm%20sunlight%2C%20deep%20navy%20and%20soft%20amber%20tone%2C%20bittersweet%20nostalgic%20mood%2C%20refined%20digital%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-special-s5&orientation=portrait",
    reason: "故事真挚、情感细腻，唤起每个人心中那段回不去的青春时光。",
    movieIds: ["2003", "2005", "1005"],
  },
  {
    id: "s6",
    title: "东方奇幻世界",
    subtitle: "瑰丽山海，想象无界",
    intro: "以东方美学构建的奇幻世界，讲述人族与灵族之间的宿命、羁绊与守护。",
    poster: "https://readdy.ai/api/search-image?query=Oriental%20fantasy%20special%20poster%2C%20a%20mystical%20floating%20island%20with%20ancient%20temples%2C%20glowing%20runes%20and%20a%20giant%20mythical%20beast%20silhouette%20in%20the%20clouds%2C%20deep%20navy%20sky%20with%20jade%20and%20gold%20accents%2C%20ethereal%20majestic%20mood%2C%20high%20detail%20digital%20painting%2C%20vertical%20poster%20composition&width=600&height=900&seq=bbtv-special-s6&orientation=portrait",
    reason: "世界观宏大、美术出众，是喜欢东方奇幻题材观众不可错过的合集。",
    movieIds: ["2002", "1002"],
  },
];